export default __webpack_public_path__ + "static/media/ai_virtual_services_select_room_en.31769be3.png";